/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from 'react';
import "@9softstudio/react-monthpicker/dist/reactmonthpicker.css";
import 'moment/locale/es';
import { closelightbox } from "../../../util/Functions";
import * as API from '../../../http/api';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import * as FORMAT from 'react-day-picker/moment';
import { format } from "../../../util/DateUtil";
import { REGEX_EMAIL } from "../../../util/RegEx";

const ContraCargoNoReconocidoCacao = (props) => {

    const [data, setData] = useState({});
    const [sectionOptions,setSectionOptions] = useState([
        {"id":"0","input":false,"text":"Cargo Periódico Cancelado o No Solicitado / TAG"},
        {"id":"2","input":false,"text":"Transacción MúltipleNo Solicitada por el Tarjetahabiente"},
        {"id":"4","input":false,"text":"Original o Copia Recibida Ilegible o con Datos Incompletos"},
        {"id":"6","input":false,"text":"Chip (EMV)"},
        {"id":"8","input":false,"text":"Transacción Manual en Terminal Electrónica"},
        {"id":"10","input":false,"text":"Transacción de Orden Telefónico/ Correo / Internet Fraudulenta"},
        {"id":"12","input":false,"text":"Tarjeta Boletinada"},
        {"id":"14","input":false,"text":"Autorización Declinada"},
        {"id":"16","input":false,"text":"Tansacción Excede Importe Autorizado o Falta de Autorizaci"},
        {"id":"18","input":false,"text":"Tarjeta Vencida"},
        {"id":"20","input":false,"text":"Presentación Extemporánea"},
        {"id":"22","input":false,"text":"Autorización Falsa"},
        {"id":"24","input":false,"text":"Peaje en Carreteras"},
        {"id":"26","input":false,"text":"Número de Cuenta Inválido"},
        {"id":"28","input":false,"text":"Copia u Original de Pagaré Solicitado no Recibido"},

        {"id":"1","input":false,"text":"Error en Proceso"},
        {"id":"3","input":false,"text":"Falta de Impresión"},
        {"id":"5","input":false,"text":"Proceso Duplicado o Múltiple"},
        {"id":"7","input":false,"text":"Falta de Firma y/o Firma en Archivo"},
        {"id":"9","input":false,"text":"Devolución no Procesada / Venta Frustrada"},
        {"id":"11","input":false,"text":"Alteración de Importe"},
        {"id":"12","input":false,"text":"Pagaré Preelaborado"},
        {"id":"15","input":false,"text":"Venta Fraccionada"},
        {"id":"17","input":false,"text":"Firma no Autorizada"},
        {"id":"19","input":false,"text":"Receptor de Pagos con Actividad Irregular"},
        {"id":"21","input":false,"text":"Receptor de Pagos Bloqueado"},
        {"id":"23","input":false,"text":"Cancelación de Reservación Garantizada, Cargos Demorados y/o"},
        {"id":"25","input":false,"text":"Pago por Otros Medios"},
        {"id":"27","input":false,"text":"Deposito por Adelantado"},
        {"id":"29","input":false,"text":"Aclaración de Transacción de Cajero Automático"},
    ]);
    const [section,setSection] = useState(true);
    const [textSection,setTextSection] = useState("");
    const [msnError,setMsnError] = useState("");
    const [msnDesc,setDesc] = useState("");
    const [disabled,setDisabled] = useState(true);
    const [startDate, setStartDate] = useState(new Date());
    const [dateDesc,setDateDesc] = useState(new Date());
    const [name,setName] = useState("");
    const [email,setEmail] = useState("");
    var   [emailSend,setEmailSend] = useState("");
    const [emailDisable,setEmailDisable] = useState(false)
    const [disabledEnvio,setDisabledEnvio] = useState(true);
    const [sendEmail, setSendEmail] = useState(false);
    const [check,setCheck] = useState([
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        }
    ])

 
    useEffect(() => {
        setData(props.data);
        if (props.config["actions"].indexOf("sendEmail") > -1) {
          setSendEmail(true);
        }
        init();
    }, []);

    const init  = async ()=>{
        setName(props.customer.name);
        setEmail(props.customer.email);
    }

    const resetChecks = ()=>{
        check.map(data=>{
            data.check = false;
        })
    }

    const handleSectionOption = (event)=>{
        let value = event.target.value;
        sectionOptions.map((data,index)=>{
            if(data.id === value){
                resetChecks();
                setMsnError("");
                sectionOptions.map((data,index)=>{
                    if(data.id === value){
                        check[data.id].check = true;
                        setTextSection(data.text)
                        setSection(false);
                        setDisabled(false)
                    }
                })
            }
        })
    }

    const resetSection = () =>{
        setTextSection("")
        setSection(true);
        setDisabled(true)
    }

    const formatDate = (date)=>{
        return format(date);
    }

    const validate = ()=>{
        
        props.changeLoader(true);
        if(textSection.length === 0){
            setMsnError("Seleccione el motivo de la reclamación")
            props.changeLoader(false);
            return false;
        }
        setMsnError("")
        return true;
    }


    const descarga = async ()=>{     
        
        if(!validate()){
            return;
        }

        let data = {
            "type": "contracargos-cacao",
            "content": {
                "card": {
                    "name": name,
                    "number":  props.data.panMasked,
                    "amount": props.data.amount.toString(),
                    "currency": props.data.currency,
                    "total": props.data.amount.toString(),
                },
                "claims": check,
                "txs": [
                    {
                        "date": formatDate(props.data.cdate),
                        "store": props.data.concept,
                        "auth": props.data.remote_account?.authorization_number,
                        "amount":  props.data.amount.toString(),
                        "currency":  props.data.currency
                    }
                ],
                "comments": {
                    "value": msnDesc,
                    "date": formatDate(dateDesc)
                }
            },
            "url": "signed",
            "agent_uuid": JSON.parse(localStorage.session).uuid,
        }

        var request = await API.service('cartasDocs', data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if(request.status === 200){
            if(request.data.data.response === "OK"){
                var dataResult = request.data.data.widget[0].content.url;
                props.changeAlert(true, 'success', 'Carta de contra cargos creada con éxito');
                window.open(dataResult, '_blank');
            }else{
                props.changeAlert(true, 'error', 'Error al crear la carta de contra cargos.');
            }
        }
        closelightbox();
        props.changeLoader(false);
    }

    const enviar = async ()=>{

        props.changeLoader(true);

        if(!validate()){
            return;
        }

        let data = {
            "type": "contracargos-cacao",
            "content": {
                "card": {
                    "name": name,
                    "number": props.data.panMasked,
                    "amount": props.data.amount.toString(),
                    "currency": props.data.currency,
                    "total":39399,
                },
                "claims": check,
                "txs": [
                    {
                        "date": formatDate(props.data.cdate),
                        "store": props.data.concept,
                        "auth": props.data.remote_account?.authorization_number,
                        "amount":  props.data.amount.toString(),
                        "currency":  props.data.currency
                    }
                ],
                "comments": {
                    "value": msnDesc,
                    "date": formatDate(dateDesc)
                }
            },
            "url": "signed",
            "agent_uuid": JSON.parse(localStorage.session).uuid,
        }

        var request = await API.service('cartasDocs', data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if(request.status === 200){
            if(request.data.data.response === "OK"){
                var url = request.data.data.widget[0].content.url;

                if(!REGEX_EMAIL.test(emailSend)){   
                    emailSend = email;
                }

                var dataSend ={
                    url:url,
                    email: emailSend,
                    docName: "Carta de cargos no reconocidos",
                    name: name
                }
          
                var requestSend = await API.service('cartasDocsSend', dataSend, props.pos, props.changeAlert, props.changeLoader, props.history);
                
                if(requestSend.status == 200 && requestSend.data.data.response === "OK"){
                    props.changeAlert(true, 'success', 'Carta de contra cargos enviada con éxito');
                }else{
                    props.changeAlert(true, 'error', 'Error al enviar la carta de contra cargos.');
                }
                
            }else{
                props.changeAlert(true, 'error', 'Error al crear la carta de contra cargos.');
            }
        }
        closelightbox();
        props.changeLoader(false);
    }

    
    const changeDateDesc = (event)=>{ 
        var value = event.toJSON().substring(0, 10);
        setDateDesc(value)
    }

    const editEmail = ()=>{
        if(emailDisable){
            setEmailDisable(false);
            setDisabledEnvio(false)
        }else{
            setEmailDisable(true);
            setDisabledEnvio(true)
        }
    }

    const newEmailSend = (event) =>{
        var value = event.target.value;
        if ( !REGEX_EMAIL.test(value)) {
            setDisabledEnvio(true)
            setEmailSend(email)
            return;
        } else {
            setDisabledEnvio(false)
            setEmailSend(value);
        }   
    }


    return (<div className="card carta-doc">
        <div className="text-right modal_header_close">
            {
              <div
                className="tooltip"
                style={{ marginRight: "10px", cursor: "pointer" }}
              >
                <span className="tooltiptext tooltip-bottom">Descargar</span>
                <i onClick={descarga} className="ibon-download"  ></i>
              </div>
            }

            <div className="tooltip">
              <span className="tooltiptext tooltip-bottom">Cerrar</span>
              <i className="ibon-close tap" onClick={closelightbox}></i>
            </div>
        </div>
        <h3 className="modal_header_title">Contracargos cacao</h3>
        
        <div className="">
            <div className="carta-form">
                <div className="carta-form-personal">
                    <p><span>Nombre del Tarjetahabiente:</span> {name} </p>
                    <p><span>Número de Tarjeta: { props.data.panMasked}</span>  </p>
                    <p><span style={{marginRight:"15px"}}>Monto Total Disputado: {props.data.amountFormated}</span> <span> Moneda {props.data.currency}</span></p>
                    <p><span>Cantidad de Transacciones Disputadas:1</span></p>
                </div>

                <div className="carta-form-section">
                    <h2>Motivo de Reclamación</h2>

                    {section &&
                        <div className="card-form-personal-data">

                    
                           <div className="col-6">
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="0" /><span className="span-carta">Cargo Periódico Cancelado o No Solicitado / TAG</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="2" /><span className="span-carta">Transacción MúltipleNo Solicitada por el Tarjetahabiente</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="4" /><span className="span-carta">Original o Copia Recibida Ilegible o con Datos Incompletos</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="6" /><span className="span-carta">Chip (EMV)</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="8" /><span className="span-carta">Transacción Manual en Terminal Electrónica</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="10" /><span className="span-carta">Transacción de Orden Telefónico/ Correo / Internet Fraudulenta</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="12" /><span className="span-carta">Tarjeta Boletinada</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="14" /><span className="span-carta">Autorización Declinada</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="16" /><span className="span-carta">Tansacción Excede Importe Autorizado o Falta de Autorizaci</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="18" /><span className="span-carta">Tarjeta Vencida</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="20"/><span className="span-carta">Presentación Extemporánea</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="22"/><span className="span-carta">Autorización Falsa</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="24"/><span className="span-carta">Peaje en Carreteras</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="26"/><span className="span-carta">Número de Cuenta Inválido</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="28"/><span className="span-carta">Copia u Original de Pagaré Solicitado no Recibido</span></p>
                           </div>
                           <div className="col-6">
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="1" /><span className="span-carta">Error en Proceso</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="3" /><span className="span-carta">Falta de Impresión</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="5" /><span className="span-carta">Proceso Duplicado o Múltiple</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="7" /><span className="span-carta">Falta de Firma y/o Firma en Archivo</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="9" /><span className="span-carta">Devolución no Procesada / Venta Frustrada</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="11" /><span className="span-carta">Alteración de Importe</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="13" /><span className="span-carta">Pagaré Preelaborado</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="15" /><span className="span-carta">Venta Fraccionada</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="17" /><span className="span-carta">Firma no Autorizada</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="19" /><span className="span-carta">Receptor de Pagos con Actividad Irregular</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="21" /><span className="span-carta">Receptor de Pagos Bloqueado</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="23" /><span className="span-carta">Cancelación de Reservación Garantizada, Cargos Demorados y/o</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="25" /><span className="span-carta">Pago por Otros Medios</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="27" /><span className="span-carta">Deposito por Adelantado</span></p>
                               <p><input type="checkbox" className="checkbox-carta" onChange={handleSectionOption.bind(this)} value="29" /><span className="span-carta">Aclaración de Transacción de Cajero Automático</span></p>
                           </div>
                       </div>
                    }

                    {!section &&
                        <p><input type="checkbox" checked onChange={resetSection}/> {textSection}</p>
                    }
                 
                </div>

                <div className='container-table-default'>
                    <table>
                        <thead>
                            <tr>
                                <th>Fecha de Transacción</th>
                                <th>Comercio</th>
                                <th>N Autorización</th>
                                <th>Monto</th>
                                <th>Moneda</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{formatDate(props.data.cdate)}</td>
                                <td>{props.data.concept}</td>
                                <td>{props.data.remote_account?.authorization_number}</td>
                                <td>{props.data.amountFormated}</td>
                                <td>{props.data.currency}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>



         
                <div className="carta-form-section">
                    <h2>Comentarios adicionales del tarjetahabiente:</h2>
                    <p>Este espacio debe utilizarlo el tarjetahabiente para describir detalladamente el motivo de su reclamo de manera que todas las partes involucradas entiendan el mismo.</p>
            
                    <textarea onChange={(e)=>{setDesc(e.target.value)}}  className="carta-textarea"></textarea>
                    <p>
                        Date
                        <DayPickerInput
                            style={{height: '30px', width: '25%',margin:'0 10px'}}
                            onDayChange={changeDateDesc}
                            placeholder='Select the date'
                            format="DD-MM-YYYY"
                            value={startDate}
                            inputProps={{
                                readOnly: true
                            }}
                            formatDate={FORMAT.default.formatDate}
                            parseDate={FORMAT.default.parseDate}
                            dayPickerProps={{
                                months: ["Ene", "Feb", "Mar","Abr", "May", "Jun","Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
                                pagedNavigation: true,
                                numberOfMonths: 1,
                            }}
                        />
                    </p>
                    
                    {sendEmail &&
                        <div className="envioCartaEmail">
                            <p>Ingresar nuevo email <i className="tap ibon-chevron-down" onClick={editEmail}></i>  </p>
                            {emailDisable &&
                                <input type="text"  style={{width:"50%"}} placeholder="Email..." className="ibon-account" onChange={newEmailSend.bind(this)} />
                            }

                            {emailDisable &&
                                <p>Se enviará a {emailSend}, {name} </p>
                            }

                            {!emailDisable &&
                                <p>Se enviará a {email}, {name}</p> 
                            }

                            <div style={{marginRight:"60px"}} className="carta-footer-col-3">
                                {
                                    <div className={ disabled ? 'disable bigButton  pnl-btn-save  pos-left' : 'bigButton pnl-btn-save  pos-left'}>
                                        <button  type="submit" onClick={enviar}>Enviar</button>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>

                {msnError != "" &&
                    <h6 className="error">{msnError}</h6>
                }

                <div className="carta-form-section">
                    <div className="carta-footer">

                        <div className="carta-footer-col">
                            <div className="bigButton pos-left">
                                <button onClick={closelightbox} >Cancelar</button>
                            </div>
                        </div>
                        
                        <div className="carta-footer-col-3">
                            <div className={disabled ? 'disable bigButton pos-right pnl-btn-save' : 'bigButton pos-right pnl-btn-save'}>
                                <button disabled={disabled} type="submit" onClick={descarga}>Descargar</button>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>)
}

export default ContraCargoNoReconocidoCacao;